import { t } from "i18next"
import * as Yup from "yup"

export const validationFile = Yup.object().shape({
  excelFile: Yup.mixed().required(t("global.you_must_select_a_file", "You must select a file"))
})
export const validationRegnr = Yup.object().shape({
  regnr: Yup.string().nullable().required(t("global.you_must_enter_regnr", "You must enter regnr")),
  propellant: Yup.string()
    .nullable()
    .required(t("global.you_must_enter_fuel_type", "You must specify fuel type")),
  odometer: Yup.string()
    .nullable()
    .required(t("global.you_must_enter_meter_reading", "You must enter your meter reading")),
  fuelVolume: Yup.string()
    .nullable()
    .required(t("global.you_must_specify_volume", "You must specify volume")),
  transactionTime: Yup.string()
    .nullable()
    .required(t("global.you_must_enter_transaction_date", "You must enter the transaction date"))
})
